// extracted by mini-css-extract-plugin
module.exports = {"container":"XhVo35fQ-3OKTmif1NsAo"};